import { useFormContext } from 'react-hook-form';
import { LwFormNumberInput } from 'redesign';

type DailyPayoutCountLimitField = {
  dailyPayoutCountLimit: number;
};

export const DailyPayoutCountLimitInput = ({
  disabled,
  helperText,
  placeholder,
  required,
}: {
  disabled?: boolean;
  helperText?: string;
  placeholder?: string;
  required?: boolean;
}) => {
  const { control } = useFormContext<DailyPayoutCountLimitField>();

  return (
    <LwFormNumberInput
      name="dailyPayoutCountLimit"
      label="Maximum dagelijks aantal uitbetalingen"
      control={control}
      rules={{
        ...(required ? { required: true } : {}),
      }}
      step={1}
      min={0}
      placeholder={placeholder}
      helperText={helperText}
      disabled={disabled}
    />
  );
};
